import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_c(VSnackbar,{attrs:{"timeout":_vm.ALERT_TIMEOUT},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n    "),_c(VBtn,{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.isVisible = false}}},[_vm._v("\n      Close\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }